<template>
  <article class="accessIndex">
    <div class="accessIndex__reload">
      <v-hover>
        <div
          @click="pagination_query=false;filterUsers(true,true);date_available=false;"
          slot-scope="{ hover }"
          class="accessIndex__reload--container"
          :class="hover?'accessIndex__interaction--hover':''">
          <img src="../../../assets/img/reload_blue.svg">
        </div>
      </v-hover>
      <p class="accessIndex__text--title">
        {{!hasAlreadyFilter?'Accesos en '+location_name :'Accesos en '+location_name+' '+dateFormat(filterSearchedDate)+' - '+dateFormat(filterSearchedDate2)}}
      </p>
    </div>
    <div class="accessIndex__general_info--actual_users">
      <section class="trainers__header">
            <div class="trainers__header--title">
            <v-breadcrumbs style="width: 100%">
                <v-icon slot="divider">chevron_right</v-icon>
                <v-breadcrumbs-item
                v-if="getUserType() !== 'Counter'"
                @click="$router.push({name: 'access'})">
                Resumen
                </v-breadcrumbs-item>
                <v-breadcrumbs-item>
                {{ location_name }}
                </v-breadcrumbs-item>
            </v-breadcrumbs>
            </div>
        </section>
        <div class="trainers__header_sublocation">
            <div
                style="cursor: pointer"
                class="trainers__header_sublocation--time_zone"
                v-if="(getUserType()=='Admin'||getUserType()=='Counter'||getUserType()=='Counter_offline') && location_name == 'Feria'"
                @click="show_modal_reward_user=true">
                <img src="https://karrottsportlife.s3-us-west-2.amazonaws.com/profile_icons/man-avatar.svg" alt="">
                <p>INVITACIÓN FERIA</p>
            </div>
            <div
                style="cursor: pointer"
                class="trainers__header_sublocation--time_zone"
                v-if="accesses.length>0 && !multiple_validation"
                @click="makeExcelReport()">
                <p>EXPORTAR REPORTE</p>
            </div>
            <div
                style="cursor: pointer"
                class="trainers__header_sublocation--time_zone"
                v-if="(getUserType()=='Admin'||getUserType()=='Counter'||getUserType()=='Counter_offline') && getCompany().access.dynamic_invitations"
                @click="active_modal_invitation=true">
                <img src="https://karrottsportlife.s3-us-west-2.amazonaws.com/profile_icons/man-avatar.svg" alt="">
                <p>ENVIAR CORTESIA</p>
            </div>
            <app-date-picker
            v-if="date_available"
            @filterQuery="pagination_query=false;filterUsersByButton($event)"></app-date-picker>
        </div>

    </div>
    <v-data-table
      :headers="headers"
      :items="accesses"
      :pagination.sync="sorter"
      hide-actions
      class="elevation-1">
      <template
          slot="items"
          slot-scope="props">
            <td v-for="item in props.item" :key="item">{{ item }}</td>
        </template>
    </v-data-table>


    <div >
        <div
        v-if="accesses.length>0&& pages > 1"
        class="accessIndex__pagination">
        <v-pagination
            color="light-blue darken-3"
            v-model="pagination.page"
            :length="pages"></v-pagination>
        <label
            class="accessIndex__pagination--general_text">{{'de '+invitations_size}}</label>
        <label
            class="accessIndex__pagination--current_text"
            v-if="(pagination.page*pagination.rowsPerPage<invitations_size)">
            {{1+pagination.rowsPerPage*(pagination.page-1)+' - '+pagination.page*pagination.rowsPerPage}}
        </label>
        <label
            class="accessIndex__pagination--current_text"
            v-else>{{1+pagination.rowsPerPage*(pagination.page-1)+' - '+invitations_size+' '}}</label>
        </div>
    </div>




    <modal-invitation
      @handleCancelModalInvitation="cancelModalInvitation"
      v-if="active_modal_invitation">
    </modal-invitation>
    <modal-reward-user
      @handleCancelModalRewardUser="cancelModalRewardUser"
      v-if="show_modal_reward_user">
    </modal-reward-user>
  </article>
</template>

<script>
import ModalInvitation from '../../views/invitations/ModalInvitation'
import ModalRewardUser from '../../views/invitations/ModalRewardUser'

export default {
    data(){
        return{
            sorter: {sortBy: 'in_date', descending: true, rowsPerPage: -1},
            saved_default_option:false,
            pagination_query:false,
            date_available:false,
            invitations_size:0,
            date: new Date().toISOString().substr(0, 10),
            date2: new Date().toISOString().substr(0, 10),
            menu: false,
            menu2:false,
            datePickerFirstClick:false,
            hasAlreadyFilter:false,
            filterSearchedDate:new Date().toISOString().substr(0, 10),
            filterSearchedDate2:new Date().toISOString().substr(0, 10),
            initialRender:true,
            pages:2,
            months:["ENE","FEB","MAR","ABR","MAY","JUN","JUL","AGO","SEP","OCT","NOV","DIC"],
            pagination: {page:1,rowsPerPage:24},
            accesses: [],
            headers: [],
            titlelocation:'',
            months_text:["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre	","Octubre","	Noviembre","Diciembre"],
            location_id: '',
            location_name: '',
            location_timezone: '',
            active_modal_invitation: false,
            show_modal_reward_user: false,
            device: false,
            pageSize:24,
            current:1,
            finalAccess: [],
            multiple_validation: false
        }
    },
    components: {
        'modal-invitation': ModalInvitation,
        'modal-reward-user': ModalRewardUser
    },
    watch: {
        'pagination.page': function (val, oldVal) {
            if(oldVal!=val&&val!=null&&oldVal!=null&&val==1&&!this.pagination_query){

            }
            else if(oldVal!=val&&val!=null&&oldVal!=null){
                this.pagination_query=true;
                this.filterUsers(false);
            }
        },
    },
    methods:{
        prev() {
         this.current--;
         this.paginated()
         console.log('backk')
        },
        next() {
         this.current+1;
         this.paginated()
        console.log('nexttt')
        },
        paginated() {
          this.finalAccess=[]
          console.log('this current', this.current)
          var indexStart = (this.current - 1) * this.pageSize
          var indexEnd = indexStart + this.pageSize

          console.log('this.pageSize', this.pageSize)

          console.log('this.indexStart', indexStart)
          console.log('indexEnd', indexEnd)
          this.finalAccess = this.accesses.slice(indexStart, indexEnd)
          console.log('this.accesses', this.finalAccess)
        },
        modifyDateFormatToStatus(datex){
            var entries=datex.split('/');
            entries=[entries[2],entries[0],entries[1]];
            return entries.join("-");
        },
        dateFormat(datex){
            var sections=datex.split("-");
            var index=Number(sections[1])-1;
            sections[1]=this.months[index];
            datex=sections.join("/");
            return datex;
        },
        dateFormatText(datex){
            const moment = require('moment-timezone');
            var time_zone = this.location_timezone;
            if(time_zone !== '' && time_zone !== null){
                var date = moment(datex).tz(time_zone).format("MM/DD/YYYY - h:mm a")
                console.log('datex', datex)
                console.log('date timezone', date)
            }else{
                var date = moment(datex).format("MM/DD/YYYY - h:mm a")
            }
            var sections=date.split("/");
            var index=Number(sections[0])-1;
            sections[0]=this.months_text[index];
            datex=sections.join(" ");

            return datex;
        },
        dateFormatTextHikvision(datex){
            const moment = require('moment-timezone');
            var time_zone = this.location_timezone;
            var format = datex.split('.')
            var format2 = datex.split('T')
            var res
            if(time_zone !== '' && time_zone !== null){
                var date = moment(datex).tz(time_zone).format("MM/DD/YYYY - h:mm a")
                console.log('datex', datex)
                console.log('date timezone', date)
            }else{
                var date = moment(datex).format("MM/DD/YYYY - h:mm a")
            }
            var sections=date.split("/");
            var index=Number(sections[0])-1;
            sections[0]=this.months_text[index];
            datex=sections.join(" ");

            return datex;
        },
        filterUsersByButton(dates){
            var object = dates != undefined && dates != null ? dates : {date_from: '', date_to: '' }
            this.date =this.modifyDateFormatToStatus(object.date_from);
            this.date2 =this.modifyDateFormatToStatus(object.date_to);
            if(object.date_from!='Desde'&&object.date_to!='Hasta'&&object.date_from!=''){
                this.datePickerFirstClick=true;
            }
            // alert(this.datePickerFirstClick+this.date+this.date2);
            if(this.datePickerFirstClick){
                this.hasAlreadyFilter=true;
                this.filterSearchedDate=this.date;
                this.filterSearchedDate2=this.date2;
                this.filterUsers(false);
            }
        },
        filterUsers(defaultOption, sync_access){
            let accessData = [];
            if(this.pagination_query){
                defaultOption=this.saved_default_option;
            }
            else{
                this.pagination.page=1;
            }
            this.saved_default_option=defaultOption;
            //alert(this.$route.params.date+" "+this.$route.params.date2+" "+this.$route.params.filter);
            // var initialDate=new Date().toISOString().substr(0, 10);
            // var lastDate=new Date().toISOString().substr(0, 10);
            var initialDate= ""
            var lastDate=""
            if(!defaultOption){
                initialDate=this.date;
                lastDate=this.date2;
                // initialDate=this.date;
                // lastDate=this.date2;
            }
            else if(this.initialRender&&this.$route.params.filter){
                this.initialRender=false;
                initialDate=this.$route.params.date;
                lastDate=this.$route.params.date2;
                this.date=this.$route.params.date;
                this.date2=this.$route.params.date2;
                this.filterSearchedDate=this.$route.params.date;
                this.filterSearchedDate2=this.$route.params.date2;
                this.datePickerFirstClick=true;
                this.hasAlreadyFilter=true;
                this.saved_default_option=false;
            }
            else{
                this.date= new Date().toISOString().substr(0, 10);
                this.date2= new Date().toISOString().substr(0, 10);
                this.datePickerFirstClick=false;
                this.hasAlreadyFilter=false;
            }
            try {
                this.$http.post('app/locations/location_permanent_key_accesses',{
                    sync_access: sync_access,
                    location_id: this.$route.params.id,
                    offset_time: new Date().getTimezoneOffset(),
                    first_date: initialDate,
                    last_date: lastDate,
                    page:this.pagination.page,
                    current:!this.hasAlreadyFilter,
                    location_name : this.location_name
                },{
                headers:
                    {
                        "X-Device-ID" : this.getDeviceId(),
                        "Authorization" : 'Bearer ' + this.getUserToken()
                    }
                }
                ).then(function(response){
                    console.log('index_location ', response)
                    // this.location_name = response.body.data.location_name;
                    this.location_timezone = response.body.location_time_zone;
                    this.accesses=[];
                    if(response.body.meta != undefined && response.body.meta != null){
                        if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                            this.checkToken(response.body.meta.authentication_token)
                        }
                    }
                    // this.accesses = response.body.data;
                    var vm =this;
                    var temp = response.body.data;

                    if (response.body.multiple_validation){
                        vm.multiple_validation = true
                        vm.headers = [
                            {text: 'Usuario', value: 'user'},
                            {text: 'Documento', value: 'user_rut'},
                            {text: 'Correo Electrónico', value: 'email'},
                            {text: 'Fecha y hora de lectura', value: 'date'},
                            {text: 'Tipo', value: 'direction'},
                            {text: 'Estado', value: 'state'}
                        ]
                        var headers_count = 0
                        var headers_index = null
                        temp.map(function(value, key) {
                            if (headers_count < Object.keys(value).length){
                                headers_count = Object.keys(value).length
                                headers_index = key
                            }
                        });
                        if (headers_count > 0){
                            Object.keys(temp[headers_index]).map(function(h) {
                                if(h.includes("validacion")){
                                    vm.headers.push({text: 'Validación ' + h.substring(11), value: h})
                                }
                            });
                        }
                    }else{
                        vm.headers = [
                            {text: 'Usuario', value: 'user'},
                            {text: 'Documento', value: 'user_rut'},
                            {text: 'Correo Electrónico', value: 'email'},
                            {text: 'Fecha y hora de acceso', value: 'date'},
                            {text: 'Tipo de acceso', value: 'direction'}
                        ]
                    }
                    // str.substring(0, str.length-1) + "-" + str.substring(str.length-1)
                    temp.map(function(value, key) {
                        var access_object = {
                            user: value["user_name"],
                            user_rut: value["user_rut"],
                            email: value["email"],
                            date: vm.dateFormatText(value["date"])
                        }
                        if (response.body.multiple_validation){
                            access_object["direction"] = vm.spanishAccessDirection(value["direction"])
                            access_object["state"] = vm.spanishState(value["state"])
                        }else{
                            access_object["type"] = value["type"]
                        }
                        Object.keys(value).map(function(h) {
                            if (h.includes("validacion")){
                                access_object[`${h}`] = value[h]
                            }
                        });
                        vm.accesses.push(access_object)
                    });

                    this.invitations_size=response.body.total_elements;
                    this.pages=response.body.pages;
                    console.log('this.pages', this.pages)

                    /* console.table(vm.accesses); */
                    this.loaded = true;
                    this.date_available=true;
                    }, function(response){
                    if (response.body.data.message != null &&
                        response.body.data.message != undefined &&
                        response.body.data.message != '' ){
                        alert(response.body.data.message)
                    }else{
                        alert(response.body.data)
                    }
                })
            } catch (e) {
                alert(e.message)
            }
        },
        cancelModalInvitation(){
            this.active_modal_invitation = false;
        },
        cancelModalRewardUser(){
            this.show_modal_reward_user = false;
        },
        makeExcelReport() {
            let accessData = [];
            let defaultOption = this.saved_default_option;
            let initialDate = ""
            let lastDate = ""
            if (!defaultOption) {
                initialDate = this.date;
                lastDate = this.date2;
            }
            else if (this.initialRender && this.$route.params.filter) {
                initialDate = this.$route.params.date;
                lastDate = this.$route.params.date2;
            }
            this.$http.post('app/locations/location_permanent_key_accesses',{
                    location_id: this.$route.params.id,
                    offset_time: new Date().getTimezoneOffset(),
                    first_date: initialDate,
                    last_date: lastDate,
                    current:!this.hasAlreadyFilter,
                    location_name : this.location_name
                },{
                headers:
                    {
                    "X-Device-ID" : this.getDeviceId(),
                    "Authorization" : 'Bearer ' + this.getUserToken()
                    }
                }
            ).then(function (response) {
                console.log('index_location ', response)

                if (response.body.meta != undefined && response.body.meta != null) {
                    if (response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null) {
                        this.checkToken(response.body.meta.authentication_token)
                    }
                }
                // this.accesses = response.body.data;
                var vm = this;
                var temp = response.body.data;


                if(response.body.device){
                    this.device = true
                }

                // str.substring(0, str.length-1) + "-" + str.substring(str.length-1)
                for (var user in temp) {
                    var rut = '';
                    if (temp[ user ][ "user_rut" ] != null) {
                        var rut = temp[ user ][ "user_rut" ];
                        rut = rut.substring(0, rut.length - 1) + "-" + rut.substring(rut.length - 1);
                    }
                    accessData.push({
                        user: temp[ user ][ "user_name" ],
                        user_rut: rut,
                        email: temp[ user ][ "email" ],
                        date: temp[ user ][ "date" ],
                        type: temp[ user ][ "type" ]
                    })
                }

                let excelData = []

                if(vm.device == true){

                     excelData = accessData.map(access => {
                        let accessInfo = {};
                        accessInfo[ "Usuario" ] = access.user;
                        accessInfo[ "Documento" ] = access.user_rut.replace(/-/g, "");
                        accessInfo[ "Correo Electrónico" ] = "";
                        accessInfo[ "Fecha y hora de acceso" ] = this.dateFormatText(access.date);
                        accessInfo[ "Tipo de Acceso" ] = access.type;
                        return accessInfo;
                    })
                }else{

                    excelData = accessData.map(access => {
                        let accessInfo = {};
                        accessInfo[ "Usuario" ] = access.user;
                        accessInfo[ "Documento" ] = access.user_rut.replace(/-/g, "");
                        accessInfo[ "Correo Electrónico" ] = access.email;
                        accessInfo[ "Fecha y hora de acceso" ] = this.dateFormatText(access.date);
                        accessInfo[ "Tipo de Acceso" ] = access.type;
                        return accessInfo;
                    })
                }

                // Stylize the excel, column width
                let colStyle = [];

                Object.keys(excelData[ 0 ]).map(title => {
                    colStyle.push({ wch: title.length + 1 });
                });


                excelData.map((accessInfo) => {
                    Object.values(accessInfo).map((values, index) => {
                        if (values.length + 1 > colStyle[ index ].wch) {
                            colStyle[ index ].wch = values.length + 1;
                        }
                    })
                });


                let data = XLSX.utils.json_to_sheet(excelData);
                data[ "!cols" ] = colStyle;
                const workbook = XLSX.utils.book_new();
                let filename = "Reporte general personalizado"

                XLSX.utils.book_append_sheet(workbook, data, filename);
                XLSX.writeFile(workbook, `${filename}.xlsx`);

            }, function (response) {
                if (response.body.data.message != null &&
                    response.body.data.message != undefined &&
                    response.body.data.message != '') {
                    alert(response.body.data.message)
                } else {
                    alert(response.body.data)
                }
            })
        },
        spanishState(state){
            if(state == "PENDING"){
                return "Pendiente"
            }else if(state === "COMPLETED"){
                return "Completada"
            }
        },
        spanishAccessDirection(direction){
            if(direction === "ENTRY"){
                return "Entrada"
            }else if(direction === "EXIT"){
                return "Salida"
            }else if(direction === "ACCESS"){
                return "Acceso"
            }
        }
    }, /* Closed methods */
    mounted(){
        // this.pagination.rowsPerPage=12;
        this.filterUsers(true);
        this.titlelocation=this.$route.params.namex;
        this.location_id = this.$route.params.id;
        this.location_name = this.$route.params.namex;
    }
}
</script>



// WEBPACK FOOTER //
// src/components/views/access/PermanentKeyAccess.vue